import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AuthenticationService } from './authentication.service';
import { OauthBffAuthenticationService } from './oauth-bff-authentication.service';

@Injectable()
export class OAuth2AuthGuard {
    private oAuthBffAuthenticationService = inject(OauthBffAuthenticationService);
    private authenticationService = inject(AuthenticationService);
    private router = inject(Router);


    async canActivate(route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        if (isErrorPage(route)) {
            return true;
        }
        
        try {
            let code = route.queryParamMap.get('code') ?? new URLSearchParams(window.location.search).get('code');

            if (code) {
                await this.oAuthBffAuthenticationService.requestSession(code);
            }
        } catch (error) {
            // When Login fails, we want to redirect to the welcome page with the error query param set to true,
            //  so that the welcome page can display an error message
            console.error('Error during OAuth2 login process', error);
            return this.router.createUrlTree([
                '/',
            ], {
                queryParams: { 
                    error: 'true',
                },
            });
        }

        if (this.authenticationService.user && this.authenticationService.containsValidRoleForThisApplication()) {
            return this.router.createUrlTree([
                '/dashboard',
            ]);
        }

        return true;
    }

    async canActivateChild(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<boolean | UrlTree> {
        return this.canActivate(route, state);
    }

}
function isErrorPage(route: ActivatedRouteSnapshot) {
    // check if the error state is requested and return true
    return route.queryParamMap.get('error') === 'true' 
    || new URLSearchParams(window.location.search).get('error') === 'true';
}

